import { __extends } from "tslib";
import StatisticHtml from '../../../components/statistic';
import { getTemplate } from './statistic-template';
var RingStatistic = /** @class */ (function (_super) {
    __extends(RingStatistic, _super);
    function RingStatistic(cfg) {
        var _this = _super.call(this, cfg) || this;
        _this.view = cfg.view;
        _this.plot = cfg.plot;
        _this.statisticClass = cfg.statisticClass;
        _this.adjustOptions();
        return _this;
    }
    RingStatistic.prototype.getTotalHtmlString = function () {
        var _a = this.plot.options, _b = _a.value, value = _b === void 0 ? 0 : _b, statistic = _a.statistic;
        if (statistic && !statistic.visible) {
            return '';
        }
        /** 中心文本显示 */
        return getTemplate(this.options.htmlContent(value), this.statisticClass);
    };
    RingStatistic.prototype.adjustOptions = function () {
        this.html = this.getTotalHtmlString();
        var _a = this.view.coordinateBBox, minX = _a.minX, minY = _a.minY, width = _a.width, height = _a.height;
        this.x = minX + width / 2;
        this.y = minY + height / 2;
    };
    return RingStatistic;
}(StatisticHtml));
export default RingStatistic;
//# sourceMappingURL=liquid-statistic.js.map